<template>
  <div>
    <div style="font-size: 22px" class="pl-4 mt-4">
      สำนักงานส่งเสริมเศรษฐกิจดิจิทัลเขตพื้นที่ภาคอีสาน สาขาภาคอีสานตอนล่าง
    </div>
    <v-divider></v-divider>
    <div class="pa-5">
      <v-row dense>
        <v-col cols="2">
          <v-icon size="30px">mdi-map-marker-outline</v-icon>
        </v-col>
        <v-col cols="10">
          <div class="pl-0">
            เลขที่ 555 ศาลากลางจังหวัดอุบลราชธานี ชั้น 3 ถนนแจ้งสนิท ต.แจระแม
            อ.เมือง จ.อุบลราชธานี 34000
          </div>
          <div class="mt-4">
            <div>Tel : 08-2700-6205</div>
            <!-- <div>Fax : 0-7637-9000</div> -->
          </div>
          <div class="mt-4">
            <!-- <div>Email : Doss@depa.or.th</div> -->
          </div>
        </v-col>
      </v-row>
      <div
        class="mt-6"
        style="position: relative; width: 100%; height: 0; padding-top: 100%"
      >
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3848.8261816408867!2d104.804126!3d15.277272!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x2aa1c53e7c17f31b!2z4Liq4Liz4LiZ4Lix4LiB4LiH4Liy4LiZ4Liq4LmI4LiH4LmA4Liq4Lij4Li04Lih4LmA4Lio4Lij4Lip4LiQ4LiB4Li04LiI4LiU4Li04LiI4Li04LiX4Lix4LilICjguKrguLLguILguLLguKDguLLguITguK3guLXguKrguLLguJnguJXguK3guJnguKXguYjguLLguIcp!5e0!3m2!1sth!2sth!4v1617785316852!5m2!1sth!2sth"
          style="
            position: absolute;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
            width: 100%;
            height: 100%;
          "
          frameborder="0"
          allowfullscreen=""
          aria-hidden="false"
          tabindex="0"
        ></iframe>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
</style>